//
//  SDKUserWorkspaceNotificationSettings.ts
//  Supernova SDK
//
export class UserWorkspaceNotificationSettings {
    constructor(model) {
        this.liveblocksNotificationSettings = model.liveblocksNotificationSettings;
    }
    static initial() {
        return new UserWorkspaceNotificationSettings({
            liveblocksNotificationSettings: {
                sendCommentNotificationEmails: true,
            },
        });
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toUpdateObject() {
        return {
            liveblocksNotificationSettings: this.liveblocksNotificationSettings,
        };
    }
    toRemote() {
        return {
            liveblocksNotificationSettings: this.liveblocksNotificationSettings,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new UserWorkspaceNotificationSettings(model);
    }
}
